import * as Message from "../../../src/Components/Message/Message.scss";
import { Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { stripHtmlTags, classNames } from "../../Utils.js";
import { equals } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { map, isEmpty, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { getMaterialIcon, SveaIcon, renderSveaIcon } from "../../ViewUtils.js";
import * as react from "react";


export class MessageKind extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Info", "Warning", "Error", "Success"];
    }
}

export function MessageKind$reflection() {
    return union_type("Components.Message.MessageKind", [], MessageKind, () => [[], [], [], []]);
}

function renderMessage(messageContent, kind) {
    let children;
    const messageClasses = classNames(ofArray([["message", true], ["message--info", equals(kind, new MessageKind(0))], ["message--warning", equals(kind, new MessageKind(1))], ["message--error", equals(kind, new MessageKind(2))], ["message--success", equals(kind, new MessageKind(3))]]));
    const iconClasses = classNames(ofArray([["message__icon", true], ["message__icon--info", equals(kind, new MessageKind(0))], ["message__icon--warning", equals(kind, new MessageKind(1))], ["message__icon--error", equals(kind, new MessageKind(2))], ["message__icon--success", equals(kind, new MessageKind(3))]]));
    const bodyClasses = classNames(ofArray([["message__body", true], ["message__body--info", equals(kind, new MessageKind(0))], ["message__body--warning", equals(kind, new MessageKind(1))], ["message__body--error", equals(kind, new MessageKind(2))], ["message__body--success", equals(kind, new MessageKind(3))]]));
    const children_4 = [(children = [renderSveaIcon((kind.tag === 1) ? (new SveaIcon(2)) : ((kind.tag === 2) ? (new SveaIcon(1)) : ((kind.tag === 3) ? (new SveaIcon(3)) : (new SveaIcon(0)))))], react.createElement("span", {
        className: iconClasses,
    }, ...children)), react.createElement("span", {
        className: bodyClasses,
    }, messageContent)];
    return react.createElement("div", {
        className: messageClasses,
    }, ...children_4);
}

export function info(message) {
    return renderMessage(stripHtmlTags(message), new MessageKind(0));
}

export function infos(messages) {
    let children_1, children_5;
    if (isEmpty(messages)) {
        return react.createElement(react.Fragment, {});
    }
    else {
        const children_7 = [(children_1 = [getMaterialIcon("info")], react.createElement("span", {
            className: "message__icon message__icon--info",
        }, ...children_1)), (children_5 = map((message) => react.createElement("div", {}, message), messages), react.createElement("span", {
            className: "message__body message__body--info",
        }, ...children_5))];
        return react.createElement("div", {
            className: "message message--info",
        }, ...children_7);
    }
}

export function warning(message) {
    return renderMessage(stripHtmlTags(message), new MessageKind(1));
}

export function warnings(messages) {
    let children_1, children_5;
    if (isEmpty(messages)) {
        return react.createElement(react.Fragment, {});
    }
    else {
        const children_7 = [(children_1 = [getMaterialIcon("info")], react.createElement("span", {
            className: "message__icon message__icon--warning",
        }, ...children_1)), (children_5 = map((message) => react.createElement("div", {}, message), messages), react.createElement("span", {
            className: "message__body message__body--warning",
        }, ...children_5))];
        return react.createElement("div", {
            className: "message message--warning",
        }, ...children_7);
    }
}

export function error(message) {
    return renderMessage(stripHtmlTags(message), new MessageKind(2));
}

export function success(message) {
    return renderMessage(stripHtmlTags(message), new MessageKind(3));
}

export function errors(messages) {
    let children_1, children_5;
    if (isEmpty(messages)) {
        return react.createElement(react.Fragment, {});
    }
    else {
        const children_7 = [(children_1 = [getMaterialIcon("info")], react.createElement("span", {
            className: "message__icon message__icon--error",
        }, ...children_1)), (children_5 = map((message) => react.createElement("div", {}, message), messages), react.createElement("span", {
            className: "message__body message__body--error",
        }, ...children_5))];
        return react.createElement("div", {
            className: "message message--error",
        }, ...children_7);
    }
}

export function customMessage(content, kind) {
    return renderMessage(content, kind);
}

